import React from 'react';
import PageError from '../../components/pageError';

const NotFound = () => (
	<PageError
		title="404, síða fannst ekki"
		text="Ýmsar ástæður getur verið því að þessi slóð er ekki til. Efnið gæti hafa verið fært annað, ekki lengur í birtingu eða jafnvel fjarlægt af vefnum." />
);

export default NotFound;
